import React from "react";
import "./YearlyCalendarUI.scss";
import Calendar from "rc-year-calendar";
import dateFormat from "dateformat";
import EventListPopover from "../EventListPopover/EventListPopover";

export default class YearlyCalendarUI extends React.Component {
  state = {
    popover: {
      showPopover: false,
    },
    eventsDateDict: {},
    eventsMonthDict: {},
    documentIds: [],
    isDataReady: false,
    isReady: false,
  };

  componentDidMount() {
    this.populateDateList(this.props.calendarEvents);
  }

  componentDidUpdate = (prevProps) => {
    if (this.props !== prevProps) {
      this.setState({ isReady: false });
      this.populateDateList(this.props.calendarEvents);
      this.closePopover();
    }
  };

  addFilesCount = () => {
    let monthsContainerChildren = this.state.isDataReady
      ? document.querySelector(".months-container").children
      : [];

    for (let i = 0; i < monthsContainerChildren.length; i++) {
      let tableChild = monthsContainerChildren[i];
      let targetElement =
        tableChild.firstChild.firstChild.firstChild.firstChild;
      let month = targetElement.innerHTML;

      if (
        this.state.eventsMonthDict[month + " " + this.props.year] !== undefined
      ) {
        //eslint-disable-next-line
        let newHTML =
          "<span class='files-count'>" +
          this.state.eventsMonthDict[month + " " + this.props.year] +
          " Files" +
          "</span>";
        targetElement.innerHTML += newHTML;
      }
    }
  };

  populateDateList = (events) => {
    if (events) {
      let eventsDateDict = {};
      let eventsMonthDict = {};
      let documentIds = [];
      const isDataReady = true;

      events.forEach((event) => {
        let date = dateFormat(event.startDate, "dd mm yyyy");
        let month = dateFormat(event.startDate, "mmmm yyyy");
        if (!documentIds.includes(event.documentId)) {
          documentIds.push(event.documentId);
          if (
            eventsMonthDict[month] !== undefined &&
            !this.state.documentIds[event.documentId]
          ) {
            eventsMonthDict[month] += 1;
          } else {
            eventsMonthDict[month] = 1;
          }
          if (eventsDateDict[date] !== undefined) {
            eventsDateDict[date].push(event);
          } else {
            eventsDateDict[date] = [event];
          }
        }
      });
      this.setState(
        { eventsDateDict, eventsMonthDict, documentIds, isDataReady },
        () => {
          this.setState({ isReady: true }, () => this.addFilesCount());
        }
      );
    }
  };

  onDayClick = (events) => {
    let rect = events.element.getBoundingClientRect();

    if (events.events.length > 0) {
      if (this.state.popover.showPopover) {
        // Turn off the effect of opened popover
        this.state.popover.element.firstChild.classList.remove("clicked-event");
      }

      events.element.firstChild.classList.add("clicked-event");
      this.setState({
        popover: {
          showPopover: true,
          top: rect.top + window.scrollY - 60,
          left: rect.right + 5,
          date: dateFormat(events.date, "mmm dd"),
          day: dateFormat(events.date, "ddd"),
          events: events.events,
          element: events.element,
        },
      });
    } else if (this.state.popover.showPopover) {
      this.closePopover();
    }
  };

  closePopover = () => {
    if (this.state.popover.element)
      this.state.popover.element.firstChild.classList.remove("clicked-event");
    this.setState({ popover: { showPopover: false } });
  };

  customDayRenderer = (dayElement, dayDate) => {
    let date = dateFormat(dayDate, "dd mm yyyy");

    if (dateFormat(new Date(), "dd mm yyyy") === date) {
      // style for current date
      dayElement.style.background = "#2f4bff";
      dayElement.style.color = "#fff";
    }
    dayElement.style.borderRadius = "50%";
    dayElement.classList.remove("has-event");
    // style for events
    if (this.state.eventsDateDict[date] !== undefined) {
      dayElement.classList.add("has-event");
    } 
    return dayElement;
  };

  render() {
    return (
      <>
        <EventListPopover
          {...this.state.popover}
          handleEventClick={this.props.handleEventClick}
          closePopover={this.closePopover}
        />

        {this.state.isDataReady && this.state.isReady && (
          <Calendar
            year={this.props.year}
            displayWeekNumber={true}
            displayHeader={false}
            dataSource={this.props.calendarEvents}
            onDayClick={this.onDayClick}
            style="custom" //eslint-disable-line
            customDayRenderer={this.customDayRenderer}
          />
        )}
      </>
    );
  }
}
